import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { getTokenUri } from '../../../../services/NFTMarketPlace/Graphquery'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { SnowBallNFTJson } from '../../data/NFTCollections/SnowBallData'
import { ISnowBallCard } from '../Cards/SnowBallCard'
import { IActivityDetail } from './ActivityDetail'
import BaseActivity from './BaseActivity'


export default function SnowBallActivtyDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const [tokenUri, setTokenUri] = useState('')
  const [detailTokenItem, setDetailTokenItem] = useState<ISnowBallCard | null>(null)
  const tokenName = `${collection.name} #${tokenId}`

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      if (SnowBallNFTJson[collection.id]) {
        setTokenUri(`https://raw.githubusercontent.com/Snowball-Finance/NFTs/main/${SnowBallNFTJson[collection.id]}`)
      } else {
        getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
      }
    }
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      {detailTokenItem ? (
        <img src={detailTokenItem.image.replace('gateway.pinata.cloud', 'ipfs.io')} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseActivity>
  )
}